<template>
  <div class="search mt-10">
    <div v-if="resFlag">
      <div v-if="!test.length">
        <div style="text-align: center">
          <img
            style="width: 71px; height: 54px"
            v-lazy="require('../assets/img/test/notest.png')"
          />
        </div>
        <div>
          <div class="text1">抱歉，没有找到相关结果</div>
          <div class="text2">建议换个关键词试试</div>
        </div>
      </div>
      <div class="content">
        <div v-for="(item, index) in test" :key="index">
          <Card :item="item"></Card>
        </div>
      </div>
    </div>
    <!--  -->
    <div v-cloak>
      <p class="ml-10 hottag" v-if="!resFlag">热门搜索</p>
      <div class="tag-group mt-10" v-if="!resFlag">
        <span
          v-for="(tag, index) in tags"
          :key="index"
          class="tag f12"
          @click="searchApi(tag)"
          >{{ tag.name }}</span
        >
      </div>
      <div class="mt-10">
        <div class="hd">
          <p class="mt-5 ml-10 test">热门测评</p>
          <span
            class="fr f14 mr-10 check_more"
            style="color: #42686e"
            @click="goMore()"
            >查看更多<img
              style="width: 7px; height: 9px; margin-left: 1px"
              v-lazy="require('../assets/img/test/right.png')"
          /></span>
        </div>
        <div class="content mt-20">
          <div v-for="(item, index) in htest" :key="index">
            <Card :item="item"></Card>
          </div>
        </div>
        <!-- <div class="all"> -->
        <van-button type="default bdr25" @click="goMore()" class="allbtn"
          >查看全部测评&nbsp;></van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/components/Card";
import { getTests, getHotTag } from "@/http/api";
export default {
  name: "Search",
  props: ["test", "flag", "resFlag", "htest"],
  data() {
    return {
      tags: ["性格", "情感"],
      // hTests: this.test
    };
  },
  watch: {
    test(val) {
      this.test = val;
    },
  },
  created() {
    getHotTag()
      .then((res) => {
        console.log(res);
        console.log(123);
        this.tags = res.data;
      })
      .catch((err) => {
        console.log(456);
        console.log("error in getHotTest", err);
      });
  },
  components: {
    Card,
  },
  methods: {
    // 搜索
    searchApi(tag) {
      this.$emit("tag", tag);
    },
    // 查看测评
    goHotTest() {},
    //查看更多
    goMore() {
      this.$router.push("./class");
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  [v-cloak] {
    display: none;
  }

  padding: 0 0 0 20px;

  .hottag {
    margin-left: 0;
  }

  .tag-group {
    width: 85%;
    margin-top: 23px;

    .tag {
      border: 1px solid #4a4a4a;
      display: inline-block;
      width: 21%;
      margin: 0 11px 11px 0;
      background-color: #fff;
      border-radius: 2px;
      color: #4a4a4a;
      line-height: 0.8rem;
      text-align: center;
    }
  }

  .tag:hover {
    border: none;
    background-color: #42686e;
    color: #fff;
  }

  .test {
    margin-top: 22px;
    margin-left: 0;
  }

  .fr {
    margin-top: -0.4rem;
  }

  .allbtn {
    width: 80%;
    position: absolute;
    left: 10%;
    margin-bottom: 75px;
  }
}

.card .detail .right {
  margin-right: 0;
}

.check_more {
  color: #9b9b9b;
}

.text1 {
  text-align: center;
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #42686e;
  line-height: 18px;
  letter-spacing: 1px;
  margin-top: 6px;
}

.text2 {
  text-align: center;
  margin-top: 4px;
  font-size: 13px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9b9b9b;
  letter-spacing: 1px;
  margin-top: 6px;
}
</style>
